<template>
  <div id="app" class="main-app-container h-100">
    <router-view/>
  </div>
</template>

<script>
import Loader from './components/misc/Loader'
export default {
  name: 'app',
  data(){
    return {
      defaultTitle: "Brink-Brink",
    }
  },
  components: {
    Loader
  },
  created(){
    document.title = this.defaultTitle;
  }
}
</script>
